import { render, staticRenderFns } from "./dg-footer.vue?vue&type=template&id=6bf0c834&scoped=true"
import script from "./dg-footer.vue?vue&type=script&lang=js"
export * from "./dg-footer.vue?vue&type=script&lang=js"
import style0 from "./dg-footer.vue?vue&type=style&index=0&id=6bf0c834&prod&scoped=true&lang=less"
import style1 from "./dg-footer.vue?vue&type=style&index=1&id=6bf0c834&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf0c834",
  null
  
)

export default component.exports